export class MfaVCode {
  MethodCode: string;
  VCode: string;
  UserId: number;
  DeviceCode: string;
}
